import { cn } from '@listening/utils/react-helpers';
import { motion, useReducedMotion } from 'framer-motion';

const barPath =
  'M0.336487 2.45956C0.336487 1.12091 1.42168 0.0357208 2.76033 0.0357208C4.09898 0.0357208 5.18417 1.12091 5.18417 2.45956V19.8745C5.18417 19.9241 5.14398 19.9643 5.0944 19.9643H2.76033C1.42168 19.9643 0.336487 18.8791 0.336487 17.5404V2.45956Z';
const dot = { cx: 12.6813, cy: 14.9819, rx: 4.98234, ry: 4.98214 };

export function DocumentInsightsMark({
  className,
  strokeWidth = 0.65,
}: {
  className?: string;
  strokeWidth?: number;
}) {
  const reducedMotion = useReducedMotion();
  const animate = reducedMotion
    ? { pathLength: 1, opacity: 1 }
    : { pathLength: [0, 1, 1, 0], opacity: [0.35, 1, 1, 0.35] };
  const transition = {
    duration: 2.8,
    repeat: reducedMotion ? 0 : Infinity,
    ease: 'easeInOut' as const,
    times: [0, 0.45, 0.65, 1],
  };
  return (
    <svg
      aria-hidden
      viewBox='-1 -1 20 22'
      className={cn('overflow-visible text-foreground', className)}
      fill='none'
      stroke='currentColor'
      strokeWidth={strokeWidth}
      strokeLinecap='round'
    >
      <g opacity={0.15} strokeWidth={strokeWidth * 0.85}>
        <path d={barPath} />
        <ellipse {...dot} />
      </g>
      <motion.path d={barPath} animate={animate} transition={transition} />
      <motion.ellipse
        {...dot}
        animate={animate}
        transition={{ ...transition, delay: reducedMotion ? 0 : 0.35 }}
      />
    </svg>
  );
}

export function DocumentInsightsLoading({ label }: { label: string }) {
  return (
    <div
      role='status'
      className='flex min-h-0 flex-1 flex-col items-center justify-center gap-5 p-6'
    >
      <DocumentInsightsMark className='h-9 w-8' />
      <p className='text-center text-xs text-muted-foreground'>{label}</p>
    </div>
  );
}
